import { render, staticRenderFns } from "./set-fatigue-driving-alarm-difference-modal.vue?vue&type=template&id=71e644e4&"
import script from "./set-fatigue-driving-alarm-difference-modal.vue?vue&type=script&lang=js&"
export * from "./set-fatigue-driving-alarm-difference-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports